$(document).on('turbo:load',() => {

  const initiateAudit = () => {

    let $doc = $(document);
    let $beginBtn = $doc.find('#begin-audit');
    let $endBtn = $doc.find('#end-audit');
    let $endMSG = $doc.find('#complete-msg');
    let $pendingMSG = $doc.find('#pending-progress');
    let $auditProgress = $doc.find('#audit-progress');

    $beginBtn.on('click', () => {
      $pendingMSG.hide();
      $endBtn.show();
      $beginBtn.hide();
      $auditProgress.show();
    });

    $endBtn.on('click', (e) => {
      $endMSG.show();
      $auditProgress.hide();
      $endBtn.hide();
    });
  };

  initiateAudit();
});